import React from "react";

import HeroEllipseGroup from "../../assets/landingPages/aboutHeroEllipsGroup.png";
import errorImg from "../../assets/landingPages/pageNotFound.png";
import { useNavigate } from "react-router-dom";

import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>404 - Page Not Found | Bil.Bio</title>
        <meta property="og:title" content="404 - Page Not Found | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] dark:bg-dark-primary pt-[93px]">
        <img
          className="absolute top-0 left-0 h-[14rem] md:h-[22rem] z-0"
          src={HeroEllipseGroup}
          alt="..."
        />
        <div className="flex justify-center z-20">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="flex flex-col items-center  lg:flex-row gap-8 lg:gap-[161px] xsmfold:px-6 xsmfold:py-[70px] sm:py-[70px] 2xl:py-20">
              <div className="text-center lg:text-left">
                <div className="text-custom_h5 text-heading_color dark:text-color_v1_dark sm:text-custom_h2 mb-5 sm:mb-[18px]">
                  Page <span className="text-main_color"> Not Found! </span>
                </div>
                <div className=" text-body_copy1_color dark:text-color_v2_dark text-small1 sm:text-body_copy1 mb-5 sm:mb-6">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  <br className="hidden md:block" />
                  Elit urna dictum placerat urna iaculis
                </div>
                <button
                  onClick={() => navigate(-2)}
                  className="sm:p-3 sm:pt-[13px] sm:px-10 p-2 pt-[9px] px-[26px] text-small2_b sm:text-small1_bold text-dark_bg_v2 dark:text-color_v2_dark rounded-full border-2 z-20 border-dark_bg_v2 dark:border-color_v2_dark"
                >
                  GO BACK
                </button>
              </div>
              <div className="xsmfold:p-5 pt-0 lg:p-9 ">
                <img src={errorImg} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageNotFound;
